import { BridgedPopover } from "~/components/stablecoins/bridged-popover";

type Props = Readonly<{
  title: string;
  tooltip?: React.ReactNode;
}>;

export function SummaryCardDescription({ title, tooltip }: Props): JSX.Element {
  return (
    <p className="flex items-center gap-x-2">
      {title} {tooltip && <BridgedPopover> {tooltip} </BridgedPopover>}
    </p>
  );
}
